import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ViewPageLiteHeaderLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPageLiteHeader" */ '../src/ViewPageLiteHeader.tsx'
			)
		).ViewPageLiteHeader,
});
